// "internal hosts" are hostnames that represent
// systems that we host or control. This is a known
// finite list and everything else is considered external.
// List pulled from DD table of unique @resource.url_host values
export const internalHostnames = [
    'api-aws.netlify.com',
    'api.netlify.com',
    'api-staging.netlify.com',
    'www.netlify.com',
    'www.netlify.app',
    'app.netlifystg.com',
    'app.netlifystg.app',
    'app.netlify.com',
    'analytics.services.netlify.com',
    'analytics-staging.services.netlify.com',
    'supportapi.services.netlify.com',
    'serve.onegraph.com',
    'list-v2--netlify-plugins.netlify.app',
    'localhost',
    'd33wubrfki0l68.cloudfront.net',
];
export const externalFunctionalityDepSubstrings = [
    'commandbar',
    'github',
    'zuora',
    'bitbucket',
    'gitlab',
    'firebase',
    'gravatar',
];
/**
 * Is this url for a service/web property that netlify owns
 *
 * @param urlString url to check
 */
export function isUrlInternal(urlString) {
    if (urlString === undefined || urlString === null) {
        return false;
    }
    const url = new URL(urlString || '', window.location.origin);
    return (url.hostname.toLowerCase().endsWith('.netlify.com') ||
        internalHostnames.includes(url.hostname.toLowerCase()) ||
        isUrlSameOrigin(urlString));
}
/**
 * Is this url the same origin of the website
 * @param urlString url to check
 */
export function isUrlSameOrigin(urlString) {
    if (urlString === undefined || urlString === null) {
        return false;
    }
    const url = new URL(urlString || '', window.location.origin);
    return url.origin === window.location.origin;
}
/**
 * Check if this URL a serverless fn call
 * @param urlString
 */
export function isUrlAServerlessFnCall(urlString) {
    if (urlString === undefined || urlString === null) {
        return false;
    }
    const url = new URL(urlString || '', window.location.origin);
    return url.pathname.startsWith('/.netlify/functions/');
}
/**
 * Is this url apart of a feature's dependency on an external service
 * to provide some functionality?
 * @param urlString
 */
export function isExternalFunctionalDep(urlString) {
    if (urlString === undefined || urlString === null) {
        return false;
    }
    const url = new URL(urlString || '', window.location.origin);
    return externalFunctionalityDepSubstrings.some((substring) => url.hostname.toLowerCase().includes(substring));
}
/**
 * Create a object representation of the server timing value that
 * allows the duration and description to automatically go upstream if set.
 * @param serverTiming a serverTiming field to translate
 * @returns object
 */
export function serverTimingToContextProps(serverTiming) {
    const props = {};
    if (Array.isArray(serverTiming)) {
        serverTiming.forEach(({ name, duration, description }) => {
            if (duration) {
                props[`st_${name}_duration`] = duration;
            }
            if (description) {
                props[`st_${name}_desc`] = description;
            }
        });
    }
    return props;
}
/**
 * Create a object representation of the performance entry for sending
 * to RUM vendor. Allows us to access all perf entry data without manually
 * sending it.
 *
 * @param performanceEntry a performanceEntry to
 * @returns object
 */
export function performanceResourceEntryToContextProps(performanceEntry) {
    if (!performanceEntry) {
        return {};
    }
    const contextProps = {
        ...performanceEntry,
        ...serverTimingToContextProps(performanceEntry === null || performanceEntry === void 0 ? void 0 : performanceEntry.serverTiming),
    };
    // delete known props that aren't useful in metrics or are transformed elsewhere
    // @ts-expect-error
    delete contextProps.name;
    // @ts-expect-error
    delete contextProps.serverTiming;
    // @ts-expect-error
    delete contextProps.entryType;
    return contextProps;
}
//# sourceMappingURL=utils.js.map